var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiowithoutlyrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 89,
    viewBox: "0 0 117 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 89,
    rx: 11,
    fill: "url(#paint0_linear_4423_139)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4322 54.1482C34.5106 41.0428 33.6312 25.668 38.7169 12.4998C52.7401 14.1175 65.9444 22.0424 73.866 35.1478C81.7876 48.2531 82.667 63.6279 77.5813 76.7962C63.5581 75.1784 50.3538 67.2535 42.4322 54.1482Z",
    fill: "url(#paint1_linear_4423_139)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2915 33.8401L75.7716 41.2201L64.2915 48.6002V33.8401Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9771 58.1668V28.5556L84.3105 24V53.6112",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1434 64.9999C53.9174 64.9999 56.9768 61.9405 56.9768 58.1665C56.9768 54.3926 53.9174 51.3332 50.1434 51.3332C46.3695 51.3332 43.3101 54.3926 43.3101 58.1665C43.3101 61.9405 46.3695 64.9999 50.1434 64.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4764 60.4444C81.2504 60.4444 84.3098 57.385 84.3098 53.6111C84.3098 49.8371 81.2504 46.7777 77.4764 46.7777C73.7025 46.7777 70.6431 49.8371 70.6431 53.6111C70.6431 57.385 73.7025 60.4444 77.4764 60.4444Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3794 24H32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3794 40.9656H32",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3793 32.4827H41.8965",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4423_139",
    x1: 90,
    y1: 2.06977,
    x2: 23.1017,
    y2: 27.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC52F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4423_139",
    x1: 40.247,
    y1: 15.0312,
    x2: 76.0512,
    y2: 74.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiowithoutlyrics);
export default __webpack_public_path__ + "static/media/audiowithoutlyrics.60d7d7490e0ffe3655937bc520fc27ef.svg";
export { ForwardRef as ReactComponent };